/** 表头全选是否覆盖当前筛选，而不是只看这一页 */
export function filterSelectionState(input: {
  total: number
  pageSize: number
  pageIds: readonly string[]
  selectedIds: ReadonlySet<string>
  /** 点过全选后记住的当前筛选可选 id。没有则只能用本页和 total 判断 */
  knownIds: readonly string[] | null
  offPageSelected?: boolean
}): { all: boolean; some: boolean } {
  const { total, pageSize, pageIds, selectedIds, knownIds, offPageSelected = false } = input
  if (knownIds) {
    const all = knownIds.length > 0 && knownIds.every((id) => selectedIds.has(id))
    const some = !all && (knownIds.some((id) => selectedIds.has(id)) || offPageSelected)
    return { all, some }
  }
  if (total <= pageSize) {
    const all = pageIds.length > 0 && pageIds.every((id) => selectedIds.has(id))
    const some = !all && pageIds.some((id) => selectedIds.has(id))
    return { all, some }
  }
  const someOnPage = pageIds.some((id) => selectedIds.has(id))
  return { all: false, some: someOnPage || offPageSelected }
}

/** 从勾选里拿掉已开通的 id。没有变化时返回原对象 */
export function omitScopeIds<T extends { app: string[]; user: string[] }>(
  selected: T,
  drop: ReadonlySet<string>,
): T {
  if (drop.size === 0) return selected
  const app = selected.app.filter((id) => !drop.has(id))
  const user = selected.user.filter((id) => !drop.has(id))
  if (app.length === selected.app.length && user.length === selected.user.length) return selected
  return { ...selected, app, user }
}

/** 批量关闭后只留下失败的行 */
export function keepSelectedIds<T>(
  selected: Map<string, T>,
  ids: ReadonlySet<string>,
): Map<string, T> {
  const next = new Map<string, T>()
  for (const [id, row] of selected) {
    if (ids.has(id)) next.set(id, row)
  }
  return next
}
